
  import { defineComponent, PropType } from 'vue';

  import TableTree from '@/common/components/redesigned/Table/TableTree/TableTree.vue';
  import { TTableTreeConfig } from '@/common/components/redesigned/Table/types/tableTypes';

  import { TStatisticsChartWithLegends } from '@/modules/admin/types/statistics/common';

  import {
    STATISTICS_PUBLIC_ACTIONS_NAME,
    STATISTICS_PUBLIC_GETTERS_NAME,
    STATISTICS_PUBLIC_MUTATIONS_NAME,
  } from '../../../store/statisticsPublic/name';
  import {
    TPublicVisitsCountByTimeTableItem,
    TStatisticsPublicFilter,
  } from '../../../types/statistics/statistics-public';
  import {
    getStatisticsChartWithLegendsConfigs,
    STATISTICS_PUBLIC_CHART_LINE_COLORS,
  } from '../../../utils/statisticsCharts';
  import { TChartBaseConfig } from '../charts/chartTypes';
  import StatisticsVerticalColumnChart from '../charts/StatisticsVerticalColumnChart.vue';
  import StatisticsByTimeTabs from '../StatisticsByTimeTabs.vue';

  export default defineComponent({
    name: 'StatisticsPublicVisitsCountByTimeTab',
    components: {
      StatisticsVerticalColumnChart,
      TableTree,
      StatisticsByTimeTabs,
    },
    props: {
      filter: {
        type: Object as PropType<TStatisticsPublicFilter>,
        required: true,
      },
    },
    data(): {
      chartConfigs: TChartBaseConfig<TStatisticsChartWithLegends>;
      tableConfig: TTableTreeConfig<TPublicVisitsCountByTimeTableItem>;
      lineColors: string[];
    } {
      return {
        chartConfigs: getStatisticsChartWithLegendsConfigs({
          action: STATISTICS_PUBLIC_ACTIONS_NAME.getVisitsCountByTimeChartData,
          mutation: STATISTICS_PUBLIC_MUTATIONS_NAME.setVisitsCountByTimeChartData,
          getter: STATISTICS_PUBLIC_GETTERS_NAME.getVisitsCountByTimeChartData,
        }),
        tableConfig: {
          columns: [
            {
              field: 'name',
              title: 'Период',
            },
            {
              field: 'visitsCount',
              title: 'Количество посещений',
              textAlign: 'right',
              width: 188,
            },
          ],
          storePaths: {
            action: STATISTICS_PUBLIC_ACTIONS_NAME.getVisitsCountByTimeTable,
            mutation: STATISTICS_PUBLIC_MUTATIONS_NAME.setVisitsCountByTimeTable,
            getter: STATISTICS_PUBLIC_GETTERS_NAME.getVisitsCountByTimeTable,
          },
          pagination: {
            size: 12,
          },
        },
        lineColors: STATISTICS_PUBLIC_CHART_LINE_COLORS,
      };
    },
  });
